import type { IconProps } from './types';

export function Blazer({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M56 56 Q128 52 200 56 Q210 58 220 60 Q220 138 220 216 Q198 220 176 216 Q172 158 168 100 Q150 122 132 144 Q128 146 124 144 Q106 122 88 100 Q84 158 80 216 Q58 220 36 216 Q36 138 36 60 Q46 58 56 56 Z" />
      <circle cx="128" cy="168" r="4" />
      <circle cx="128" cy="192" r="4" />
    </svg>
  );
}
